import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form--nested-fields"
// Handles dynamic add/remove of nested fields in forms
export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()

    const wrapper = event.target.closest("[data-nested-field]")
    if (!wrapper) return

    const destroyInput = wrapper.querySelector("input[name*='_destroy']")

    if (destroyInput) {
      // Mark for destruction if it's a persisted record
      destroyInput.value = "1"
      wrapper.style.display = "none"
    } else {
      // Remove from DOM if it's a new record
      wrapper.remove()
    }
  }
}
